import './CustomCheck.css';

const CustomCheck = ({
  description = '',
  descriptionSize = 'sm',
  descriptionColor = 'gray',
  handleCheck = () => {},
  ...rest
}) => {
  const handleChange = (e) => {
    handleCheck(e.target.checked);
  };

  return (
    <div className="container-check">
      <label>
        <input className="input-check" type="checkbox" onChange={handleChange} {...rest}></input>
        <span className="span-checkbox"></span>
      </label>
      <span style={{ fontSize: descriptionSize, color: descriptionColor }} className="description">
        {description}
      </span>
    </div>
  );
};

export default CustomCheck;
